var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page ld"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/imgs/logo.png"),"alt":""}}),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"reProg",style:('width:'+_vm.prog+ '%;')})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }